import React, { useEffect } from 'react';
import { SearchBreadcrumb, SearchBreadcrumbModifier } from '../../../../SearchBreadcrumb';
import { DownloadFileIcon } from '../../../../../../_lib/components/Download';
import Btn, { BtnModifier } from '../../../../Btn';
import { Icons } from '../../../../../atoms/SVG';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { sendLiveRegionMessage } from '../../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { PagePackStates } from '../../../../../../types/api/PagePackState';
import { StateIndicator } from '../../../../../../_lib/components/StateIndicator';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';

type ContentPreview = Partial<TopContentResult> & { reset(): void; pagePackState?: PagePackStates };

export function ContentPreview({
  pageLink,
  breadcrumb,
  teasertext,
  attachment,
  fileExtension,
  reset,
  pagePackState,
}: ContentPreview) {
  const { t } = useSonTranslation('FormsComboBox');
  const pageLinkName = pageLink?.name;

  useEffect(() => {
    if (pageLinkName) {
      sendLiveRegionMessage(t('contentPreview.hint', { name: pageLinkName }));
    }
  }, [pageLinkName, t]);

  return (
    <div className="content-preview">
      <h3 className="content-preview__headline invisible">{t('contentPreview.content')}</h3>
      <div className="content-preview__wrapper">
        <div className="content-preview__content">
          <p className="content-preview__title">
            {pagePackState === 'onlyDraftVersion' && <StateIndicator status="red" />}
            {attachment && fileExtension && <DownloadFileIcon modifier="relative" fileExtension={fileExtension} />}
            {pageLinkName}
          </p>
          {breadcrumb && (
            <SearchBreadcrumb
              clickable={false}
              breadcrumbs={breadcrumb}
              modifier={SearchBreadcrumbModifier.NO_MARGIN_BOTTOM}
            />
          )}
          {teasertext && <p className="content-preview__teasertext">{teasertext}</p>}
        </div>
        <Btn
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.DELETE_X_SMALL}
          type="button"
          text={t('contentPreview.deleteButtonText')}
          titleText={t('contentPreview.deleteButtonText')}
          hiddenText
          tooltipPlacement={TooltipPlacement.LEFT}
          onClick={reset}
        />
      </div>
    </div>
  );
}
